<template>
    <div class="index-instruments">
        <Container width="landing">
            <h2 class="index-instruments__title">
                Инструменты сервиса
            </h2>

            <IndexInstrumentsTabs v-if="false" class="index-instruments__tabs" :tabs="tabs" />

            <div class="index-instruments__list">
                <IndexInstrumentsSearch />
            </div>
        </Container>
    </div>
</template>

<script setup lang="ts">
    import Container from '~/src/shared/components/common/Container/Container.vue'
    import IndexInstrumentsSearch from '~/src/shared/components/pages/index/IndexInstruments/IndexInstrumentsSearch.vue'
    import IndexInstrumentsTabs from '~/src/shared/components/pages/index/IndexInstruments/IndexInstrumentsTabs.vue'

    const tabs = [
        {
            label: 'Поиск трафика',
            value: 'search',
        },
        {
            label: 'Мониторинг позиций',
            value: 'monitoring',
        },
        {
            label: 'Редирект',
            value: 'redirect',
        },
    ]
</script>

<style scoped lang="scss">
    //

    .index-instruments {
        padding: 60px 0 100px;

        @include respond-to(mobile) {
            padding: 40px 0;
        }

        &__tabs {
            margin-top: 40px;
        }

        &__title {
            @include mulish40b;
        }

        &__list {
            margin-top: 24px;
        }
    }
</style>
